import React from 'react';

function Card(props) {
  return (
    <div className="card">
      <br />
      <div className="text-center">
        <img
          alt="card-img"
          src={"/img/" + props.img}
          className="text-center img-fluid"
          style={props.imgStyle} // Apply custom styles if passed
        />
      </div>
      <div className="text-center">
        <h3 className="card-title">{props.title}</h3>
      </div>
      <div className="p-3">
        {/* Dynamically render paragraph or list */}
        {Array.isArray(props.text) ? (
          <ul className="card-text">
            {props.text.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        ) : (
          <p className="card-text">{props.text}</p>
        )}
      </div>
      <div className="text-center">
        {/* Conditionally render the button only if showButton is true */}
        {props.showButton && (
          <button className="btn" onClick={props.onClick}>
            {props.buttonLabel || "Explore"} {/* Default to 'Explore' */}
          </button>
        )}
      </div>
    </div>
  );
}

export default Card;
